module.exports = __webpack_public_path__ + "resources/img/img_speech_to_text2_m.79f8593e0e3c767c2b2508a3c045de00.png";